import '../Vendors'; //global available Vendors

import './polyfills';
import { mx } from './globals';

import * as angular from 'angular';

import appModule from './app.module';

import '../DebugHelper/MxDebugHelper';
import errorTemplate from '../ErrorPage/mx-shell-error-message/mx-shell-error-message.html';

import(/* webpackChunkName: "shell" */ './index.scss');

document.execCommand('ClearAuthenticationCache', false);

// Log hidden errors so the app doesn't get stuck with no message in the console.
window.addEventListener('unhandledrejection', (e) => {
	console.error('Unhandled init rejection:', e.reason);
});

// Entry point
angular.element(async function () {
	try {
		await mx.getConfigJson();
		angular.bootstrap(document.querySelector('html') as HTMLHtmlElement, [appModule]);
	} catch (e) {
		console.error('Init failed:', e);

		const isNoCertificateError = e instanceof Error && e.message === 'NO_VALID_CERTIFICATE';

		const lng = navigator.language.slice(0, 2) || 'en';

		const translations = {
			noLicense: {
				en: 'No License',
				de: 'Keine Lizenz',
				cs: 'Žádná Licence',
				da: 'Ingen Licens',
				es: 'Sin Licencia',
				fr: 'Pas de Licence',
				it: 'Nessuna Licenza',
				nl: 'Geen Licentie',
				no: 'Ingen Lisens',
				pl: 'Brak Licencji',
				pt: 'Sem Licença',
				ru: 'Нет Лицензии',
				ar: 'لا توجد رخصة',
				zh: '无许可证',
				sv: 'Ingen Licens',
				sk: 'Žiadna Licencia',
				fi: 'Ei Lisenssiä',
			},
			initError: {
				en: 'Initialization Error',
				de: 'Initialisierungsfehler',
				cs: 'Chyba Inicializace',
				da: 'Initialiseringsfejl',
				es: 'Error de Inicialización',
				fr: "Erreur d'Initialisation",
				it: 'Errore di Inizializzazione',
				nl: 'Initialisatiefout',
				no: 'Initialiseringsfeil',
				pl: 'Błąd Inicjalizacji',
				pt: 'Erro de Inicialização',
				ru: 'Ошибка Инициализации',
				ar: 'خطأ في التهيئة',
				zh: '初始化错误',
				sv: 'Initieringsfel',
				sk: 'Chyba Inicializácie',
				fi: 'Alustusvirhe',
			},
		};

		const t = (key: keyof typeof translations) => translations[key][lng as keyof (typeof translations)[typeof key]] || translations[key]['en'];

		const title = isNoCertificateError ? t('noLicense') : t('initError');

		const rendered = errorTemplate.replace('{{:: vm.errorTitle }}', title).replace('{{:: vm.error }}', '');
		document.write(rendered);
	}
});
